import { generalId, PathwayStatus, ProtocolListAssignment } from '@app/advisor-shared';
import { dbObjectToId, reduceToMap } from '@nu-art/ts-common';
import { getProtocolActions } from './get-protocol-actions.js';
import { ModuleFE_Advisor_Pathway, ModuleFE_RuntimeProtocol } from '@app/advisor-frontend';
export const getMetapathwayActions = () => {
    const hcProtocols = ModuleFE_RuntimeProtocol.cache.filter(protocol => protocol.listAssignment === ProtocolListAssignment.CONSIDER_NOW);
    const actionMap = reduceToMap(hcProtocols, dbObjectToId, p => getProtocolActions(p, true));
    return hcProtocols.reduce((actions, protocol) => {
        const protocolActions = actionMap[protocol._id];
        //If the protocol has no actions to take
        const awaitingTestResultsCandidate = !protocolActions.orders.length && !protocolActions.groups.length && !protocolActions.disposition.length && !protocol.neededVariables.length && protocol.variableIds[0] !== generalId;
        if (awaitingTestResultsCandidate) {
            const pathway = ModuleFE_Advisor_Pathway.cache.unique(protocol.pathwayId);
            //Protocol should only show up as "awaiting test results" if:
            // - it has no other actions to take.
            // - not the general protocol.
            // - not a single state protocol (since it never has actions to take).
            // - not a CC protocol (since it is "complete" when it has no actions to take).
            // - not in re-assessment
            if (pathway.type === 'single-state' || pathway.type === 'chief-complaint' || protocol.status === PathwayStatus.REACHED_REASSESSMENT)
                return actions;
            actions.awaitingTestResults.push(protocol);
            return actions;
        }
        //Combine runtime orders
        protocolActions.orders.forEach(rtOrder => {
            let action = actions.orders.find(action => action.rtOrder._id === rtOrder._id);
            if (!action)
                actions.orders.push(action = { rtOrder, protocols: [] });
            if (!action.protocols.find(p => p._id === protocol._id))
                action.protocols.push(protocol);
        });
        //Combine order groups
        protocolActions.groups.forEach(group => {
            let action = actions.groups.find(action => action.groupId === group.groupId);
            if (!action)
                actions.groups.push(action = { groupId: group.groupId, runtimeOrders: group.runtimeOrders, protocols: [] });
            if (!action.protocols.find(p => p._id === protocol._id))
                action.protocols.push(protocol);
        });
        //Combine disposition
        protocolActions.disposition.forEach(disposition => {
            let action = actions.dispo.find(action => action.type === disposition);
            if (!action)
                actions.dispo.push(action = { type: disposition, protocols: [] });
            if (!action.protocols.find(p => p._id === protocol._id))
                action.protocols.push(protocol);
        });
        return actions;
    }, {
        orders: [],
        groups: [],
        dispo: [],
        awaitingTestResults: []
    });
};
//# sourceMappingURL=get-metapathway-actions.js.map